import colors from 'assets/theme/base/colors';
import pxToRem from 'assets/theme/function/px-to-rem';
import typography from 'assets/theme/base/typography';
import { breakpoints } from 'assets/theme/base/breakpoints';

const dialogTitle = {
    styleOverrides: {
        root: {
            color: colors.common.white,
            fontSize: typography.size.xxxxl,
            fontWeight: typography.fontWeightMedium,
            paddingTop: pxToRem(20),
            paddingBottom: pxToRem(20),

            [breakpoints.down('md')]: {
                fontSize: typography.size.xxl,
                paddingTop: pxToRem(15),
                paddingBottom: pxToRem(15),
            },

            [breakpoints.down('sm')]: {
                fontSize: typography.size.xl,
            },

            /*paddingLeft: pxToRem(3),
            paddingRight: pxToRem(0),*/
        },
    },
};

export default dialogTitle;
